import { useCallback } from 'react'
import { produce } from 'immer'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type CollapsibleState = "expanded" | "collapsed"

type Store = {
  state: Record<string, CollapsibleState>
}

const useCollapsibleStore = create<Store>()(persist(() => ({
  state: {}
}), {
  name: "collapsible-store-v1"
}))

export function useCollapsible(
  id: string,
  defaultExpanded?: boolean
) {
  const collapsibleState = useCollapsibleStore(s => {
    return id in s.state
      ? s.state[id]
      : (defaultExpanded ? "expanded" : "collapsed")
  })
  const toggle = useCallback(() => {
    useCollapsibleStore.setState(
      produce((draft: Store) => {
        draft.state[id] = collapsibleState === "expanded" ? "collapsed" : "expanded"
      })
    )
  }, [ id, collapsibleState ])
  return [ collapsibleState, toggle ] as const
}
